// ExampleShowcase.jsx
import React, { useMemo, useState } from "react";
import "./css/ExampleShowcase.css";
import blueIcon from "../assets/blue-icon.png";
import Babershop from '../assets/barbershop.jpg';
import Saloon from '../assets/saloon.jpg';
import Handyman from '../assets/handyman.JPG'
import PetGrooming from '../assets/PetGrooming.jpg'
import B2B from '../assets/B2B.jpg'
import landscaping from '../assets/landscaping.jpg'
import FoodTruck from '../assets/FoodTruck.jpg'
import restaurant from '../assets/restaurant.jpg'


export default function ExampleShowcase() {
  // All categories + filter state
  const CATEGORIES = [
    "All",
    "Barbershop",
    "Salon & Spa",
    "Handyman",
    "Pet Grooming",
    "Business Services",
    "Landscaping",
    "Food Truck",
    "Restaurant",
  ];
  const [active, setActive] = useState("All");

  // Demo projects (swap image URLs with your own thumbnails if you have them)
  const projects = useMemo(
    () => [
      {
        id: "barbershop-1",
        title: "Classic Fade Studio",
        category: "Barbershop",
        metric: "↑ 38% bookings",
        badge: "Barbershop",
        desc:
          "Sharper brand, online booking, and local SEO that drives walk-ins.",
        image:Babershop,
        link:"https://websolutionusa.com/templates/barbershop/",
      },
      {
        id: "salon-1",
        title: "Luna Salon & Spa",
        category: "Salon & Spa",
        metric: "↑ 46% enquiries",
        badge: "Saloon",
        desc:
          "Service menus, gift cards, and membership plans presented beautifully.",
        image:Saloon,
        link:"https://websolutionusa.com/templates/saloon/",

      },
      {
        id: "handyman-1",
        title: "FixIt Handyman Co.",
        category: "Handyman",
        metric: "↑ 52% quote requests",
        badge: "Handyman",
        desc:
          "Clear services, before/after gallery, and instant quote form.",
        image:Handyman,
       link:"https://websolutionusa.com/templates/handyman/",
      },
      {
        id: "pet-1",
        title: "Paws & Suds Grooming",
        category: "Pet Grooming",
        metric: "↑ 41% bookings",
        badge: "Pet Grooming",
        desc:
          "Online booking, add-on packages, and cute gallery that converts.",
        image:PetGrooming,
       link:"https://websolutionusa.com/templates/pet-grooming/",
      },
      {
        id: "biz-1",
        title: "NorthBridge Consulting",
        category: "Business Services",
        metric: "↑ 29% leads",
        badge: "B2B",
        desc:
          "Case-study driven website with lead magnets and Calendly integration.",
        image:B2B,
       link:"https://websolutionusa.com/templates/business-services//",
      },
      {
        id: "land-1",
        title: "GreenScape Landscaping",
        category: "Landscaping",
        metric: "↑ 35% enquiries",
        badge: "Landscaping",
        desc:
          "Service areas, seasonal promos, and project showcase with testimonials.",
        image:landscaping,
       link:"https://websolutionusa.com/templates/landscaping/",
      },
      {
        id: "truck-1",
        title: "Taco Tempo Truck",
        category: "Food Truck",
        metric: "↑ 2× event bookings",
        badge: "Food Truck",
        desc:
          "Rotating menu, schedule map, and catering enquiry flow.",
        image:FoodTruck,
       link:"https://websolutionusa.com/templates/food-truck/",
      },
      {
        id: "restaurant-1",
        title: "Olive & Ember",
        category: "Restaurant",
        metric: "↑ 47% reservations",
        badge: "Restaurant",
        desc:
          "Mouth-watering menu pages, OpenTable integration, and gift cards.",
        image:restaurant,
       link:"https://websolutionusa.com/templates/restaurant/",
      },
    ],
    []
  );

  const visible =
    active === "All" ? projects : projects.filter((p) => p.category === active);

  return (
    <section className="showcase-wrap" id="work">
      <header className="showcase-header">
        <span className="sh-badge"><img  className="blue-icon" src={blueIcon} alt="blueicon" /> Real Results</span>
        <h2 className="sh-title">
          See What We’ve <span>Built</span>
        </h2>
        <p className="sh-sub">
          Real websites for real businesses. Each designed to convert visitors into customers.
        </p>

        {/* Filter Chips */}
        <nav className="sh-filters" aria-label="Filter by category">
          {CATEGORIES.map((c) => (
            <button
              key={c}
              className={`sh-chip ${active === c ? "active" : ""}`}
              onClick={() => setActive(c)}
              type="button"
            >
              {c}
            </button>
          ))}
        </nav>
      </header>

      {/* Cards */}
      <div className="sh-grid">
        {visible.map((p) => (
          <article key={p.id} className="sh-card">
            <div className="sh-thumb">
              <img src={p.image} alt={`${p.title} website preview`} loading="lazy" />
            </div>

            <div className="sh-body">
              <div className="sh-topline">
                <span className="sh-pill">{p.badge}</span>
                <span className="sh-metric">{p.metric}</span>
              </div>

              <h3 className="sh-name">{p.title}</h3>
              <p className="sh-desc">{p.desc}</p>

              <div className="sh-actions">
                <a  href={p.link} target="_blank" rel="noopener noreferrer" className="btn-primary">
                View Live
                </a>
                <a  href={p.link} target="_blank" rel="noopener noreferrer" className="btn-eg-ghost">
                Case Study
                </a>
              </div>
            </div>
          </article>
        ))}
      </div>
    </section>
  );
}
